import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";

export const getScheduleDetail = createAsyncThunk('schedule/getScheduleDetail',
	async ({ id, success }: { id: string, success?: Function }) => {
		const url = `/v1/closed-schedules/${id}`
		const response: AxiosResponse<ScheduleDetailState> = await instance.get(url)
		success(response.data)
		return response.data
	})

export const createSchedule = createAsyncThunk('schedule/createSchedule',
	async (data: any) => {
	const url = `/v1/closed-schedules`
	const response: AxiosResponse<ScheduleState> = await instance.post(url, data)
	return response.data
	}
)

export const updateSchedule = createAsyncThunk('schedule/updateSchedule',
	async ({ id, data }: { id: string, data: any }) => {
		const url = `/v1/closed-schedules/${id}`
		const response: AxiosResponse<ScheduleState> = await instance.put(url, data)
		return response.data
	}
)
